import { FleContinueWrapper, FleLayout } from "../FleLayout"
import { ContinueArrow, SwitchH1ToH2 } from "../Molecules"
import { FlexRowCenter, Spacer } from "../../atoms/Atoms"
import { IlloUnderwaterChecklist } from "../../atoms/Illustrations"
import { Body } from "../../atoms/Bodies"
import React, { useLayoutEffect } from "react"
import { TopSection } from "../TopSection"
import { AboutYouTopSection } from "components/carrot-plans/shared/ProgressTracker"
import { useHistory } from "react-router"
import { useAboutYouFlowControls } from "../context/AboutYouFlowContext"
import useAboutYou from "../hooks/useAboutYou"
import CarrotClient from "carrot-api"
import Settings from "../../../../utils/CarrotConfig"
import { useCurrentUser } from "../../../context/user/UserContext"

const client = new CarrotClient(Settings.CARROT_BACKEND_URL)

const AboutYouIntro = ({ next }) => {
  const history = useHistory()
  const { wentBack } = useAboutYouFlowControls()
  const { data } = useAboutYou()
  const { refreshUserInfo, carrotPlansRoutingStarted } = useCurrentUser()
  useLayoutEffect(() => {
    if (!wentBack && data?.dateOfBirth && carrotPlansRoutingStarted) {
      history.push(next)
    }
  }, [data?.dateOfBirth, history, next, wentBack, carrotPlansRoutingStarted])
  return (
    <FleLayout
      closeButton
      bottomContent={
        <FleContinueWrapper>
          <ContinueArrow
            onClick={async () => {
              if (carrotPlansRoutingStarted === null) {
                await client.startCarrotPlansEnrollment().then(refreshUserInfo)
              }
              history.push(next)
            }}
          />
        </FleContinueWrapper>
      }
    >
      <AboutYouTopSection>
        <TopSection progressStep={2} />
      </AboutYouTopSection>
      <FlexRowCenter>
        <IlloUnderwaterChecklist />
      </FlexRowCenter>
      <Spacer height={3} />
      <SwitchH1ToH2>Tell us more</SwitchH1ToH2>
      <Spacer height={1} />
      <Body color="black-80">
        So that we can pair you with the right expert to create your Carrot Plan, please tell us more about yourself,
        where you are in your family-forming journey, and how we can help right now.
      </Body>
    </FleLayout>
  )
}

export { AboutYouIntro }
